export default __webpack_public_path__ + "static/media/shg.802eddef.jpg";